import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import UUID from 'uuid-js';
const EventType = new Enum(['UNKNOWN', 'CREATION', 'COMP', 'VOID', 'UNCOMP', 'DELETE', 'SPLIT', 'FIRE', 'SEND']);
const ISO8601Date = ProtoBaseModel.extend({
  dateString: attr(String)
});
const MobileStaff = ProtoBaseModel.extend({
  userToken: attr(String),
  readOnlyName: attr(String),
  readOnlyProfilePhotoUrl: attr(String),
  readOnlyMobileStaffId: attr(String)
});
const Employee = ProtoBaseModel.extend({
  employeeToken: attr(String),
  readOnlyFullName: attr(String),
  readOnlyProfilePhotoUrl: attr(String),
  firstName: attr(String),
  lastName: attr(String),
  readOnlyEmployeeNumber: attr(String)
});
const DeviceCredential = ProtoBaseModel.extend({
  token: attr(String),
  name: attr(String)
});
const CreatorDetails = ProtoBaseModel.extend({
  mobileStaff: attr(MobileStaff),
  employee: attr(Employee),
  deviceCredential: attr(DeviceCredential)
});
export const ChildItemization = ProtoBaseModel.extend({
  ticketTokenPair: attr(TokenPair),
  childItemizationTokenPair: attr(TokenPair),
  clone() {
    return ChildItemization.create({
      ticketTokenPair: TokenPair.create({
        clientToken: UUID.create().toString()
      }),
      childItemizationTokenPair: TokenPair.create({
        clientToken: UUID.create().toString()
      })
    });
  }
});
export const SplitEventDetails = ProtoBaseModel.extend({
  childItemization: attr(ChildItemization),
  clone() {
    return SplitEventDetails.create({
      childItemization: this.childItemization && this.childItemization.clone()
    });
  }
});
const ItemizationEvent = ProtoBaseModel.extend({
  eventTokenPair: attr(TokenPair),
  eventType: attr(EventType),
  createdAt: attr(ISO8601Date),
  creatorDetails: attr(CreatorDetails),
  reason: attr(String),
  splitEventDetails: attr(SplitEventDetails),
  clone() {
    const itemizationEventClone = ItemizationEvent.deserialize(ItemizationEvent.serialize(this));
    itemizationEventClone.setProperties({
      eventTokenPair: TokenPair.create({
        clientToken: UUID.create().toString()
      }),
      splitEventDetails: this.splitEventDetails && this.splitEventDetails.clone()
    });
    return itemizationEventClone;
  }
});
export default ItemizationEvent;